/* ============
 * Getters for the website module
 * ============
 *
 * The getters that are available on the
 * website module.
 */
import router from "@/router/index";

export default {
  website: state => {
    return state.website;
  },
  fetchPages: state => {
    let menuPages = state.website.website.pages;

    if (state.website.website.privacy === 1) {
      menuPages = _.filter(state.website.website.pages, {access: state.website.page.access});
    }
    return menuPages
  },
  fetchUuid: state => {
    let self = this
    if (router.currentRoute.params.slug !== undefined) {
      let page = state.website.website.pages.find(page => page.slug === router.currentRoute.params.slug)
      return page.uuid
    } else {
      return state.website.page.uuid
    }
  }
};
